import { useRef, useEffect } from "react";
import { useInput, useResourceContext } from "react-admin";
import { cfWorkerValidator as validator } from "./CfWorkerValidator";
import { withTheme } from "@rjsf/core";
import { Theme } from "@rjsf/mui";
import React from "react";
import { getDefaultFormState } from "@rjsf/utils";
import { useFormContext, useWatch } from 'react-hook-form';

const MuiForm = withTheme(Theme);

export const JsonSchemaInput = (props) => {
  const { schema, uiSchema = {}, source, defaultValue, isEdit } = props;  

  const resource = useResourceContext(props);
  const formRef = useRef();
  const defaults = getDefaultFormState(validator, schema, {});
  const form = useFormContext();
  const values = useWatch();

  const validate = (value) => {
    const result = validator.validateFormData(value ?? {}, schema);
    if (result?.errors?.length > 0) {
      return result.errors[0].message || result.errors[0].stack;
    }
    return undefined;
  };

  const {
    field,
    // eslint-disable-next-line
    fieldState: { invalid, isTouched },
    formState: { isLoading },
  } = useInput({ 
    defaultValue : isEdit ? { ...defaults, ...JSON.parse(defaultValue || "{}") } : defaults,
    resource, 
    source, 
    validate 
  });

  const onChange = (e, id) => {
    if (!isLoading && id) {
      if (e.formData) {
        field.onChange(e.formData);
      }
    }
  };

  useEffect(() => {
    if(!isEdit){
      const schemaDefaults = getDefaultFormState(validator, schema, {});
      form.setValue(source, schemaDefaults, {shouldValidate : true})
    }    
    // eslint-disable-next-line
  },[values.reportThemeVersionId, schema, isEdit])

  return (
    <MuiForm
      ref={formRef}
      schema={schema}
      uiSchema={uiSchema}
      formData={isEdit ? { ...JSON.parse(defaultValue || "{}"), ...field.value } : field.value }
      validator={validator}
      onChange={onChange}
      liveValidate
      showErrorList={false}
    >
      <></>
    </MuiForm>
  );
};

export default JsonSchemaInput;
